import React, { useState } from 'react';
import { Mail, Check, ArrowRight } from 'lucide-react';
import { useT } from '../i18n';

/* DigestSignup — "Get the Monday digest" capture for the Intelligence Hub.
   Subscribes to the Brevo newsletter list via /api/newsletter. */

const API = process.env.REACT_APP_BACKEND_URL;

export default function DigestSignup() {
  const { lang } = useT();
  const es = lang === 'es';
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');

  const submit = async (e) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) return setStatus('error');
    setStatus('loading');
    try {
      const r = await fetch(`${API}/api/newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, locale: lang, source_page: '/intelligence' }),
      });
      setStatus(r.ok ? 'success' : 'error');
      if (r.ok) {
        try {
          const { trackEvent } = await import('../lib/analytics');
          trackEvent('newsletter_signup', { location: 'digest' });
        } catch { /* noop */ }
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className="py-4" data-testid="digest-signup">
      <div className="max-w-[880px] mx-auto px-6 lg:px-10">
        <div className="rounded-3xl border border-white/10 bg-white/[0.04] p-7 sm:p-9 flex flex-col md:flex-row md:items-center gap-6">
          <div className="flex-1">
            <p className="text-[10px] tracking-[0.22em] uppercase font-bold text-[#FF9B4A]">
              Kitxens · Weekly Intelligence
            </p>
            <h3 className="mt-2 text-xl sm:text-2xl font-bold text-white tracking-[-0.015em]">
              {es ? 'Recibe el resumen de los lunes.' : 'Get the Monday digest.'}
            </h3>
            <p className="mt-1.5 text-[13.5px] text-neutral-400 leading-relaxed">
              {es
                ? 'Lo mejor del sector, curado por Penny cada lunes — EN y ES, 3 minutos de lectura.'
                : "The week's best sector intelligence, curated by Penny every Monday — 3-minute read."}
            </p>
          </div>
          {status === 'success' ? (
            <p className="inline-flex items-center gap-2 text-emerald-400 font-semibold text-[14px]" data-testid="digest-signup-success">
              <Check className="w-4 h-4" /> {es ? '¡Listo! Nos vemos el lunes.' : "You're in! See you Monday."}
            </p>
          ) : (
            <form onSubmit={submit} className="flex w-full md:w-auto gap-2">
              <div className="relative flex-1 md:w-64">
                <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-500" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); if (status === 'error') setStatus('idle'); }}
                  placeholder={es ? 'tu@restaurante.com' : 'you@restaurant.com'}
                  className={`w-full h-12 rounded-full bg-white/[0.06] border pl-10 pr-4 text-[14px] text-white placeholder:text-neutral-500 outline-none transition-colors ${
                    status === 'error' ? 'border-red-500/60' : 'border-white/15 focus:border-[#F77F11]'
                  }`}
                  data-testid="digest-signup-email"
                />
              </div>
              <button
                type="submit"
                disabled={status === 'loading'}
                className="shrink-0 inline-flex items-center gap-1.5 h-12 px-5 rounded-full bg-[#F77F11] hover:bg-[#d8651a] disabled:opacity-60 text-white text-[14px] font-semibold transition-colors"
                data-testid="digest-signup-submit"
              >
                {status === 'loading' ? '…' : es ? 'Suscribirme' : 'Subscribe'} <ArrowRight className="w-4 h-4" />
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
}
